export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";